import { render, staticRenderFns } from "./CreateBlog.vue?vue&type=template&id=08e1b086&"
import script from "./CreateBlog.vue?vue&type=script&lang=js&"
export * from "./CreateBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateBlog.vue"
export default component.exports